
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_934W1eH0TuQKMeta } from "/builds/1tool/damage-report/pages/additional-services/[id].vue?macro=true";
import { default as _91id_93F359jCdA0qMeta } from "/builds/1tool/damage-report/pages/annotations/[id].vue?macro=true";
import { default as indexBT3slXRbwkMeta } from "/builds/1tool/damage-report/pages/calendar/index.vue?macro=true";
import { default as _91id_932LjSHwCFCuMeta } from "/builds/1tool/damage-report/pages/cause-of-damage/[id].vue?macro=true";
import { default as _91id_93T3iOl6u9zzMeta } from "/builds/1tool/damage-report/pages/declaration-of-assignment/[id].vue?macro=true";
import { default as indexSKqijg7vMrMeta } from "/builds/1tool/damage-report/pages/events/index.vue?macro=true";
import { default as _91id_937ma0MVvlu2Meta } from "/builds/1tool/damage-report/pages/exterior-view/[id].vue?macro=true";
import { default as indexIKKJ1cDxd7Meta } from "/builds/1tool/damage-report/pages/index.vue?macro=true";
import { default as indexQPGqxSZllMMeta } from "/builds/1tool/damage-report/pages/login/index.vue?macro=true";
import { default as _91id_93yiXqIaGPRsMeta } from "/builds/1tool/damage-report/pages/measurement-protocol/[id].vue?macro=true";
import { default as _91id_93IiZNC4Lf6PMeta } from "/builds/1tool/damage-report/pages/project-data/[id].vue?macro=true";
import { default as _91id_93SAk7FXxssaMeta } from "/builds/1tool/damage-report/pages/recommended-actions/[id].vue?macro=true";
import { default as indexS3NZdV9kPqMeta } from "/builds/1tool/damage-report/pages/reports/index.vue?macro=true";
import { default as _91id_93DNGLJNXKU6Meta } from "/builds/1tool/damage-report/pages/service-setup/[id].vue?macro=true";
export default [
  {
    name: "additional-services-id",
    path: "/additional-services/:id()",
    component: () => import("/builds/1tool/damage-report/pages/additional-services/[id].vue")
  },
  {
    name: "annotations-id",
    path: "/annotations/:id()",
    component: () => import("/builds/1tool/damage-report/pages/annotations/[id].vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/builds/1tool/damage-report/pages/calendar/index.vue")
  },
  {
    name: "cause-of-damage-id",
    path: "/cause-of-damage/:id()",
    component: () => import("/builds/1tool/damage-report/pages/cause-of-damage/[id].vue")
  },
  {
    name: "declaration-of-assignment-id",
    path: "/declaration-of-assignment/:id()",
    component: () => import("/builds/1tool/damage-report/pages/declaration-of-assignment/[id].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/builds/1tool/damage-report/pages/events/index.vue")
  },
  {
    name: "exterior-view-id",
    path: "/exterior-view/:id()",
    component: () => import("/builds/1tool/damage-report/pages/exterior-view/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/damage-report/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/1tool/damage-report/pages/login/index.vue")
  },
  {
    name: "measurement-protocol-id",
    path: "/measurement-protocol/:id()",
    component: () => import("/builds/1tool/damage-report/pages/measurement-protocol/[id].vue")
  },
  {
    name: "project-data-id",
    path: "/project-data/:id()",
    component: () => import("/builds/1tool/damage-report/pages/project-data/[id].vue")
  },
  {
    name: "recommended-actions-id",
    path: "/recommended-actions/:id()",
    component: () => import("/builds/1tool/damage-report/pages/recommended-actions/[id].vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/builds/1tool/damage-report/pages/reports/index.vue")
  },
  {
    name: "service-setup-id",
    path: "/service-setup/:id()",
    component: () => import("/builds/1tool/damage-report/pages/service-setup/[id].vue")
  }
]